module.exports = "enter-teamroom-arrow"